import { template as template_cbd81dec21754b5f9eee59727e4595ac } from "@ember/template-compiler";
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import { t } from 'ember-intl';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
export default class BiPanelLocation extends Component {
    @service
    stationRepo;
    @service
    store;
    @service
    intl;
    @tracked
    isDisplayed = false;
    constructor(){
        super(...arguments);
        this.isDisplayed = this.args.stationIds?.length > 0;
        this.args.initParam('stationIds', this.args.stationIds);
    }
    @action
    onChange(station) {
        this.args.updateParam('stationIds', [
            station.id
        ]);
    }
    get stationOptions() {
        return this.stationRepo.stations;
    }
    get selectedStation() {
        const selectedId = this.args.getParam('stationIds');
        if (selectedId == null) {
            return null;
        }
        const selectedStation = this.getStationModel(selectedId[0]);
        return selectedStation ?? null;
    }
    get selectedStationBadgeText() {
        const appliedStationId = this.args.stationIds[0];
        const appliedStation = this.getStationModel(appliedStationId);
        return `${this.intl.t('station')}: ${appliedStation?.name}`;
    }
    getStationModel(stationId) {
        return this.stationOptions.find(({ id })=>{
            return id === stationId;
        });
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_cbd81dec21754b5f9eee59727e4595ac(`
      <Portal @target="filter-fields">
        <FilterWrapper
          class="bi-location-filter"
          @class="align-items-end"
          @form={{@form}}
          @label="biPanel.selectOneStation"
          @isDisplayed={{this.isDisplayed}}
          @onChecked={{this.onDisplayedChanged}}
          @hasValue={{isPresent this.selectedStation}}
          ...attributes
        >
          <div class="input-group">
            <div class="col">
              <div class="row">
                <div class="col">
                  <@form.element
                    class="bi-station-select"
                    @controlType="power-select"
                    @value={{this.selectedStation}}
                    @options={{this.stationOptions}}
                    @optionLabelPath="name"
                    @onChange={{this.onChange}}
                    @noMatchesMessage={{t "noMatch"}}
                  as |el|>
                    <el.control
                      class="sm"
                      @searchEnabled={{true}}
                      @searchField="name"
                      @placeholder={{t "biPanel.noSelectedStations"}}
                    />
                  </@form.element>
                </div>
              </div>
            </div>
          </div>
        </FilterWrapper>
      </Portal>

      <Portal @target="search-badge-tags">
        <SearchTag
          @isDisplayed={{@stationIds}}
          @text={{this.selectedStationBadgeText}}
        />
      </Portal>
    `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
